/** Formatage commun à toute l'interface (D-08 : FCFA en entiers, D-14 : français). */

const fcfa = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });

/** 125000 → « 125 000 FCFA » */
export function formatFCFA(amount: number): string {
  return `${fcfa.format(Math.round(amount))} FCFA`;
}

/** Date ISO → « 24/09/2026 ». */
export function formatDate(iso: string | null | undefined, timeZone?: string): string {
  if (!iso) return '';
  const date = iso.length === 10 ? new Date(`${iso}T00:00:00Z`) : new Date(iso);
  return new Intl.DateTimeFormat('fr-FR', {
    dateStyle: 'short',
    timeZone: iso.length === 10 ? 'UTC' : timeZone,
  }).format(date);
}

/** Date ISO → « 24/09/2026 14:05 » */
export function formatDateTime(iso: string | null | undefined, timeZone?: string): string {
  if (!iso) return '';
  return new Intl.DateTimeFormat('fr-FR', {
    dateStyle: 'short',
    timeStyle: 'short',
    timeZone,
  }).format(new Date(iso));
}

/** Date ISO → « 14:05 » */
export function formatTime(iso: string | null | undefined, timeZone?: string): string {
  if (!iso) return '';
  return new Intl.DateTimeFormat('fr-FR', { timeStyle: 'short', timeZone }).format(new Date(iso));
}

/** Âge en années révolues à une date donnée. */
export function ageInYears(birthDate: string, at: Date = new Date()): number {
  const birth = new Date(`${birthDate}T00:00:00`);
  let age = at.getFullYear() - birth.getFullYear();
  const beforeBirthday =
    at.getMonth() < birth.getMonth() ||
    (at.getMonth() === birth.getMonth() && at.getDate() < birth.getDate());
  if (beforeBirthday) age -= 1;
  return age;
}

/** « 36 ans », « 8 mois », « 12 jours » : âge lisible, y compris pour les nourrissons. */
export function formatAge(birthDate: string | null | undefined, estimated = false): string {
  if (!birthDate) return 'Âge inconnu';
  const now = new Date();
  const years = ageInYears(birthDate, now);
  const prefix = estimated ? '~' : '';
  if (years >= 2) return `${prefix}${years} ans`;
  const birth = new Date(`${birthDate}T00:00:00`);
  const months =
    (now.getFullYear() - birth.getFullYear()) * 12 +
    now.getMonth() -
    birth.getMonth() -
    (now.getDate() < birth.getDate() ? 1 : 0);
  if (months >= 1) return `${prefix}${months} mois`;
  const days = Math.max(0, Math.floor((now.getTime() - birth.getTime()) / 86_400_000));
  return `${prefix}${days} jour${days > 1 ? 's' : ''}`;
}

/** Taille de fichier lisible. */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} Ko`;
  return `${(bytes / 1024 / 1024).toFixed(1)} Mo`;
}

/** Date locale du jour au format AAAA-MM-JJ. */
export function todayISO(date: Date = new Date()): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}
